/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

// Historical Address.phone values were saved straight from the masked input,
// so unfilled extension slots persist as trailing underscore placeholders in
// the database — either a fully-empty " ____" suffix or a partially-filled
// "12__" one (digits then underscores, no leading space). \s*_+$ strips the
// trailing underscores in both cases for view-mode rendering only, keeping any
// entered digits; edit mode still needs the mask placeholders so the cursor
// can step into the extension slot.
const PLACEHOLDER_SUFFIX = /\s*_+$/;

export const PhoneUtils = {
    FormatForDisplay(value) {
        if (value == null) return value;
        return String(value).replace(PLACEHOLDER_SUFFIX, '');
    },
};
